import React, { useState } from "react";
import { Link } from "gatsby";

import {
  Root,
  Container,
  Logo,
  Body,
  Section,
  Title,
  NavList,
  NavLink,
  SocialContainer,
  SocialLink,
  TopContainer,
  BottomContainer,
  Legal,
  ToTopButton,
} from "./Footer.style";

import logoSrc from "../../assets/logo.png";
import instagramSrc from "../../assets/icon-instagram.svg";
import facebookSrc from "../../assets/icon-facebook.svg";
import youtubeSrc from "../../assets/icon-youtube.svg";

import { ModalEntry } from "../ModalEntry/ModalEntry";
import { ModalRules } from "../../ModalRules/ModalRules";
import { Button } from "../../Button/Button";

export const Footer = () => {
  const [entryShow, setEntryShow] = useState(false);
  const [rulesShow, setRulesShow] = useState(false);
  const [rulesFromEntry, setRulesFromEntry] = useState(false);

  return (
    <Root>
      <Container>
        <TopContainer>
          <Logo as={Link} to="/">
            <img src={logoSrc} alt="Ole Smoky" />
          </Logo>

          <Body>
            <Section>
              <Title>SUPPORT</Title>
              <NavList>
                <li>
                  <NavLink as="button" onClick={() => setRulesShow(true)}>
                    Sweepstakes Rules
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    target="_blank"
                    href="https://olesmoky.com/pages/privacy"
                  >
                    Privacy policy
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    target="_blank"
                    href="https://olesmoky.com/pages/contact"
                  >
                    Contact
                  </NavLink>
                </li>
              </NavList>
            </Section>

            <Section>
              <Title className="--social">SOCIAL</Title>
              <SocialContainer>
                <SocialLink
                  target="_blank"
                  href="https://www.instagram.com/olesmoky/?hl=en"
                >
                  <img src={instagramSrc} alt="instagram" />
                </SocialLink>
                <SocialLink
                  target="_blank"
                  href="https://www.facebook.com/olesmoky"
                >
                  <img src={facebookSrc} alt="facebook" />
                </SocialLink>
                <SocialLink
                  target="_blank"
                  href="https://www.youtube.com/channel/UCHiz5-YT3yX0VqkfGKKy3zw"
                >
                  <img src={youtubeSrc} alt="youtube" />
                </SocialLink>
              </SocialContainer>
            </Section>

            <Section>
              <Title>Enter for a chance to win</Title>
              <Button type="button" onClick={() => setEntryShow(true)}>
                enter for a chance to win
              </Button>
            </Section>
          </Body>
        </TopContainer>

        <BottomContainer>
          <Legal>
            <a href="mailto:customerservice@osdistillery.com">
              customerservice@osdistillery.com
            </a>
            <p>
              ©{new Date().getFullYear()} Ole Smoky Distillery, LLC,
              Gatlinburg, TN. All Rights Reserved.
            </p>
          </Legal>
          <ToTopButton to="home" duration={150} spy={true} />
        </BottomContainer>
      </Container>

      {entryShow && <ModalEntry onClose={() => setEntryShow(false)} />}

      {rulesShow && (
        <ModalRules
          onClose={() => {
            setRulesShow(false);
            if (rulesFromEntry) {
              setRulesFromEntry(false);
              setEntryShow(true);
            }
          }}
        />
      )}
    </Root>
  );
};
